import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../models/paginated-response';
import { ClientSite } from '../models/client-site';
import { Client } from '../models/client';
import { EligibilitySite } from '../models/eligibility-site';
import { EligibilityFile } from '../models/eligibility-file';

@Injectable({
  providedIn: 'root',
})
export class ImportService {
  constructor(private readonly http: HttpClient) {}

  searchClient(query: string, limit: number = 100): Observable<PaginatedResponse<Client[]>> {
    return this.http.get<PaginatedResponse<Client[]>>(`${environment.backendBaseUrl}/import/adista/clients`, {
      params: {
        query: query,
        limit: limit,
        active: true
      }
    });
  }

  getClientLocations(clientId: number): Observable<PaginatedResponse<ClientSite[]>> {
    return this.http.get<PaginatedResponse<ClientSite[]>>(`${environment.backendBaseUrl}/import/adista/clients/${clientId}/locations`, {
      params: {
        limit: 1000,
        active: true
      }
    });
  }

  importSitesFromAdistaLocations(sessionCode: string, siteIds: number[]): Observable<EligibilitySite[]> {
    return this.http.post<EligibilitySite[]>(`${environment.backendBaseUrl}/sessions/${sessionCode}/sites/import/adista/locations`, siteIds);
  }

  getSessionFile(sessionCode: string): Observable<EligibilityFile> {
    return this.http.get<EligibilityFile>(``);
  }

  importCSVFile(sessionCode: string, file: File): Observable<EligibilityFile> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<EligibilityFile>(`${environment.backendBaseUrl}/sessions/${sessionCode}/files`, formData);
  }

  importSitesFromCSVFile(sessionCode: string, fileUuid: string, siteRows: number[], columns: (string | undefined | null)[]): Observable<EligibilitySite[]> {
    return this.http.post<EligibilitySite[]>(`${environment.backendBaseUrl}/sessions/${sessionCode}/sites/import/files/${fileUuid}`, {rows: siteRows, columns});
  }
}
